/** API на том же домене: Caddy проксирует /api/* в api, в dev — прокси Vite. */
export const API_BASE = '/api/v1'

/** Бот, из которого оператор открывает админку как Mini App. */
export const BOT_URL = import.meta.env.VITE_BOT_URL ?? 'https://t.me/get_slot_ru_bot'

/** Username бота для Telegram Login Widget; домен админки привязан к нему через /setdomain в @BotFather. */
export const BOT_USERNAME = import.meta.env.VITE_BOT_USERNAME ?? 'get_slot_ru_bot'
